import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const PageContainer = styled.div`
  width: 100%;
  background: #ffffff;
`;

const HeroSection = styled.section`
  padding: 80px 100px 60px;
  background: linear-gradient(135deg, #453793 0%, #5a4bb5 100%);
  color: white;
  text-align: center;

  h1 {
    font-size: 42px;
     color: white;
    font-weight: 700;
    margin-bottom: 20px;
  }

  p {
    font-size: 20px;
    max-width: 700px;
    margin: 0 auto;
    line-height: 1.6;
    color: rgba(255, 255, 255, 0.9);
  }

  @media (max-width: 768px) {
    padding: 60px 20px 40px;
    h1 { font-size: 32px; }
    p { font-size: 18px; }
  }
`;

const ServicesSection = styled.section`
  padding: 80px 100px;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

//const SectionTitle = styled.h2`
//  font-size: 36px;
//  font-weight: 700;
//  text-align: center;
//  margin-bottom: 60px;
//  color: #333;
//`;

const ServiceGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;
  margin-bottom: 80px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
      margin-bottom: 0px;
  }
`;

const ServiceCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  border: 2px solid #f0f0f0;
  transition: all 0.3s ease;

  &:hover {
    border-color: #8ecf41;
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }

  h3 {
    font-size: 26px;
    color: #453793;
    margin-bottom: 15px;
    font-weight: 600;
  }

  .tagline {
    font-size: 16px;
    color: #666;
    margin-bottom: 25px;
    line-height: 1.6;
  }

  .price {
    font-size: 18px;
    color: #8ecf41;
    font-weight: 600;
    margin-bottom: 25px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  li {
    padding: 10px 0;
    padding-left: 30px;
    position: relative;
    color: #555;
    line-height: 1.6;

    &:before {
      content: "✓";
      position: absolute;
      left: 0;
      color: #8ecf41;
      font-weight: bold;
      font-size: 18px;
    }
  }
`;

const LearnMoreButton = styled(Link)`
  display: inline-block;
  margin-top: 20px;
  padding: 12px 30px;
  background-color: #453793;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #5a4bb5;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(69, 55, 147, 0.3);
  }
`;

const DetailSection = styled.div`
  background: #f8f9fa;
  border-radius: 12px;
  padding: 50px;
  margin-bottom: 60px;

  h3 {
    font-size: 28px;
    color: #453793;
    margin-bottom: 30px;
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

const DetailGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
`;

const DetailItem = styled.div`
  h4 {
    font-size: 18px;
    color: #333;
    margin-bottom: 10px;
    font-weight: 600;
  }

  p {
    font-size: 15px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }
`;

const TechStack = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  border-left: 5px solid #8ecf41;

  h3 {
    font-size: 24px;
    color: #333;
    margin-bottom: 20px;
  }

  .stack-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .tech-badge {
    padding: 10px 20px;
    background: #f0f0f0;
    border-radius: 6px;
    font-size: 14px;
    color: #555;
    font-weight: 500;
  }
`;

const CTASection = styled.section`
  padding: 80px 100px;
  background: linear-gradient(135deg, #453793 0%, #5a4bb5 100%);
  text-align: center;
  color: white;

  h2 {
    font-size: 36px;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    margin-bottom: 40px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 768px) {
    padding: 60px 20px;
  }
`;

const CTAButton = styled(Link)`
  display: inline-block;
  padding: 15px 40px;
  background-color: #8ecf41;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #72b237;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(142, 207, 65, 0.3);
  }
`;

function Services() {
    return (
        <PageContainer>
            {/* HERO */}
            <HeroSection>
                <h1>Services</h1>
                <p>
                    From fractional CTO leadership to full-stack development and government contracting,
                    we provide the technical expertise growing companies need.
                </p>
            </HeroSection>

            {/* MAIN SERVICES */}
            <ServicesSection>
                <ServiceGrid>
                    {/* FRACTIONAL CTO */}
                    <ServiceCard>
                        <h3>Fractional CTO Services</h3>
                        <p className="tagline">
                            Strategic technical leadership for 15-20 hours per month.
                            Get C-level expertise without the full-time cost.
                        </p>
                        <p className="price">Starting at $10,000/month</p>
                        <ul>
                            <li>Technical roadmap and architecture decisions</li>
                            <li>Hiring strategy and team building guidance</li>
                            <li>Cloud cost optimization (30% savings consistently)</li>
                            <li>Executive-level communication to board/investors</li>
                            <li>Technology vendor selection and management</li>
                            <li>Security and compliance guidance</li>
                            <li>DevOps and CI/CD strategy</li>
                        </ul>
                    </ServiceCard>

                    {/* CUSTOM DEVELOPMENT */}
                    <ServiceCard>
                        <h3>Custom Development</h3>
                        <p className="tagline">
                            Full-stack application development tailored to your specific needs.
                            From concept to deployment.
                        </p>
                        <p className="price">Project-based: $25,000 - $100,000+</p>
                        <ul>
                            <li>React/Node.js web applications</li>
                            <li>React Native mobile apps</li>
                            <li>Azure cloud architecture and deployment</li>
                            <li>AI integration (LLMs, translation, automation)</li>
                            <li>Healthcare systems (HIPAA-compliant)</li>
                            <li>M365/SharePoint modernization</li>
                            <li>API development and integrations</li>
                        </ul>
                    </ServiceCard>

                    {/* GOVERNMENT CONTRACTING */}
                    <ServiceCard>
                        <h3>Government Contracting</h3>
                        <p className="tagline">
                            WOSB certification pending. Qualified for federal and state projects.
                            Experience with healthcare IT and enterprise systems.
                        </p>
                        <p className="price">Request Capabilities Statement</p>
                        <ul>
                            <li>Healthcare IT (HIPAA-compliant systems)</li>
                            <li>Cloud migration and modernization</li>
                            <li>Custom application development</li>
                            <li>M365/SharePoint solutions</li>
                            <li>DevOps and CI/CD implementation</li>
                            <li>SBIR/STTR collaboration opportunities</li>
                            <li>SAM.gov registered (WOSB certification in progress)</li>
                        </ul>
                    </ServiceCard>

                    {/* ZUMODO PRODUCT */}
                    <ServiceCard style={{ borderColor: '#8ecf41', borderWidth: '3px' }}>
                        <h3>ZumoDO - Our Product</h3>
                        <p className="tagline">
                            Your day, organized by when you actually do things. Our own mobile app,
                            and a working sample of what we build. Available on Android, iOS coming soon.
                        </p>
                        <p className="price" style={{ color: '#453793' }}>Download on Google Play</p>
                        <ul>
                            <li>Smart task management with repeating schedules</li>
                            <li>Goal tracking and projects</li>
                            <li>Calendar integration</li>
                            <li>Day Focus to name what a whole day is about</li>
                            <li>Color-coded categories</li>
                            <li>React Native + Azure + Cosmos DB</li>
                            <li>Join iOS waitlist on our showcase page</li>
                        </ul>
                        <LearnMoreButton to="/zumodo">Learn More & Download</LearnMoreButton>
                    </ServiceCard>
                </ServiceGrid>

                {/* FRACTIONAL CTO DETAILS */}
                <DetailSection>
                    <h3>What's Included in Fractional CTO Services</h3>
                    <DetailGrid>
                        <DetailItem>
                            <h4>Strategic Guidance</h4>
                            <p>
                                Technical roadmap development, architecture decisions, technology stack recommendations,
                                and build vs. buy analysis.
                            </p>
                        </DetailItem>
                        <DetailItem>
                            <h4>Team Leadership</h4>
                            <p>
                                Hiring strategy, candidate interviewing, team structure, engineering process improvement,
                                and mentoring.
                            </p>
                        </DetailItem>
                        <DetailItem>
                            <h4>Executive Communication</h4>
                            <p>
                                Board and investor updates, technical strategy presentations, budget planning,
                                and vendor negotiations.
                            </p>
                        </DetailItem>
                        <DetailItem>
                            <h4>Infrastructure & Operations</h4>
                            <p>
                                Cloud cost optimization (Azure specialist), security and compliance guidance,
                                DevOps strategy, disaster recovery planning.
                            </p>
                        </DetailItem>
                        <DetailItem>
                            <h4>Typical Engagement</h4>
                            <p>
                                15-20 hours per month, 1-2 video calls per week, Slack/email access for urgent questions,
                                monthly written updates for stakeholders.
                            </p>
                        </DetailItem>
                        <DetailItem>
                            <h4>Who It's For</h4>
                            <p>
                                Series A-C startups ($2M-20M raised), bootstrapped SaaS companies ($500K-5M revenue),
                                mid-market companies (100-500 employees) modernizing tech.
                            </p>
                        </DetailItem>
                    </DetailGrid>
                </DetailSection>

                {/* TECH STACK */}
                <TechStack>
                    <h3>Technical Expertise</h3>
                    <div className="stack-grid">
                        <div className="tech-badge">React</div>
                        <div className="tech-badge">TypeScript</div>
                        <div className="tech-badge">Node.js</div>
                        <div className="tech-badge">React Native</div>
                        <div className="tech-badge">Azure</div>
                        <div className="tech-badge">Cosmos DB</div>
                        <div className="tech-badge">Azure Functions</div>
                        <div className="tech-badge">Azure AI Services</div>
                        <div className="tech-badge">M365</div>
                        <div className="tech-badge">SharePoint</div>
                        <div className="tech-badge">Power Platform</div>
                        <div className="tech-badge">GitHub Actions</div>
                        <div className="tech-badge">CI/CD</div>
                        <div className="tech-badge">Algolia</div>
                        <div className="tech-badge">Cloudflare</div>
                        <div className="tech-badge">HIPAA Compliance</div>
                    </div>
                </TechStack>
            </ServicesSection>

            {/* CTA */}
            <CTASection>
                <h2>Ready to Get Started?</h2>
                <p>
                    Schedule a free 15-minute discovery call to discuss your technical challenges
                    and how we can help.
                </p>
                <CTAButton to="/contact">Send a Message</CTAButton>
            </CTASection>
        </PageContainer>
    );
}

export default Services;